import { useStartAPetitionPageFcm } from '../../../../pageFcm';
import { DEFAULT_CONFIG } from '../../configs';
import type { StepConfig } from '../../types';

export function useCurrentSteps(): StepConfig[] {
	const fcm = useStartAPetitionPageFcm();

	const getDefaultSteps = (): StepConfig[] => {
		return DEFAULT_CONFIG.filter((step: StepConfig) => {
			return step.isEnabled(fcm);
		});
	};

	return getDefaultSteps();
}
